module.exports = "//public.zight.com/packs/media/images/activity-8924dc57d3828c6d9145bd98627cbb45.svg";